// extracted by mini-css-extract-plugin
export default {"img":"Cream_img__6dVhr"};